import { render } from "./TermsConditionsOverview.vue?vue&type=template&id=0b3a9999&ts=true"
import script from "./TermsConditionsOverview.vue?vue&type=script&lang=ts"
export * from "./TermsConditionsOverview.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__